import React, { useEffect, useState } from "react";
import Sidebar from "../Side/Sidebar";
import Topbar from "../Side/Topbar";
import AOS from "aos";
import "aos/dist/aos.css";
import Card from "../Cards/Card";
import TextCard from "../Cards/TextCard";
import {
  BanknotesIcon,
  CurrencyDollarIcon,
  CalendarDaysIcon,
  ChartBarSquareIcon,
} from "@heroicons/react/24/outline";
import { useAuth } from "../Auth/AuthContext";
import AdminSidebar from "../Side/AdminSidebar";
import RevenueChart from "../Dashboards/RevenueChart";
import axios from "axios";
import RevenueSimulator from "../Dashboards/RevenueSimulator";
import PerformanceScore from "../Dashboards/PerformanceScore";
import AIOptimizationTips from "../Dashboards/AIOptimizationTips";
import { baseUrl } from '../../config/appsettings';

const Overview = () => {
  const { authState } = useAuth();
  const role = authState.roles;
  const admin = role === "Admin";

  const [revenues, setRevenues] = useState({
    todays: 0,
    yesterday: 0,
    lastsevendays: 0,
    thismonth: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    fetchCardRevenues();
  }, []);

  const fetchCardRevenues = async () => {
    try {
      const userId = authState.user.id;
      const response = await axios.get(`${baseUrl}analytics/GetCardsRevenue/${admin}&&${userId}`);
      if (response.data && response.data.isSuccess) {
        setRevenues(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching revenues:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-gray-50">
      {/* Sidebar */}
      {admin ? <AdminSidebar /> : <Sidebar />}

      {/* Content Area */}
      <div className="flex-1 flex flex-col">
        {/* Topbar */}
        <Topbar />

        {/* Main Dashboard */}
        <main className="pt-[100px] px-4 sm:px-6 lg:px-10 pb-10 bg-gray-50">
          {/* Revenue Cards */}
          <section className="max-w-7xl mx-auto" data-aos="fade-up">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              <div data-aos="fade-right" data-aos-delay="100">
                <Card title="Today's So Far" value={`$${revenues.todays}`} color="text-blue-800" icon={BanknotesIcon} />
              </div>
              <div data-aos="fade-right" data-aos-delay="200">
                <Card title="Yesterday" value={`$${revenues.yesterday}`} color="text-yellow-800" icon={CurrencyDollarIcon} />
              </div>
              <div data-aos="fade-right" data-aos-delay="300">
                <Card title="Last 7 Days" value={`$${revenues.lastsevendays}`} color="text-green-800" icon={CalendarDaysIcon} />
              </div>
              <div data-aos="fade-right" data-aos-delay="400">
                <Card title="This Month" value={`$${revenues.thismonth}`} color="text-red-800" icon={ChartBarSquareIcon} />
              </div>
            </div>
          </section>

          {/* Info Card */}
          <section className="mt-10 max-w-7xl mx-auto" data-aos="fade-zoom-in" data-aos-delay="150">
            <TextCard />
          </section>

          {/* Revenue Chart */}
          <section className="mt-12 max-w-7xl mx-auto" data-aos="fade-left" data-aos-delay="200">
            <h2 className="text-xl font-semibold text-gray-700 mb-4">Revenue Chart</h2>
            <RevenueChart />
          </section>

          {/* Performance Score */}
          <section className="mt-12 max-w-7xl mx-auto" data-aos="zoom-in-up" data-aos-delay="250">
            <h2 className="text-xl font-semibold text-gray-700 mb-4">Performance Score</h2>
            <PerformanceScore />
          </section>

          {/* AI Optimization Tips */}
          <section className="mt-12 max-w-7xl mx-auto" data-aos="fade-up" data-aos-delay="300">
            <h2 className="text-xl font-semibold text-gray-700 mb-4">AI Optimization Tips</h2>
            <AIOptimizationTips />
          </section>

          {/* Revenue Simulator */}
          <section className="mt-12 max-w-7xl mx-auto" data-aos="fade-up" data-aos-delay="350">
            <h2 className="text-xl font-semibold text-gray-700 mb-4">Revenue Simulator</h2>
            <RevenueSimulator />
          </section>

        </main>

      </div>
    </div>
  );
};

export default Overview;
